export interface JobDto {
  category: string;
  title: string;
  desc: string;
  date: string;
  locations: string[];
  type: string;
  requirement?: string;
  level?: number; // 优先级
}
export const socialJobs: JobDto[] = [
  {
    category: "开发",
    title: "高级后端开发工程师",
    // 职位要求
    requirement: `1、参与公司AI产品的大客户定制开发和私有化部署交付的全研发流程，包括需求分析、开发、测试、交付等；
2、根据客户需求给出合适的技术方案，根据方案设计合理的技术架构，攻坚难点任务并参与核心模块的具体开发；
3、能将不同用户需求进行抽象，形成标准化方案。`,
    // 职位描述
    desc: `1、计算机，通信，电子工程或相关专业本科及以上毕业，具备3年以上的开发工作经验；
2、具有良好的编程思想和编码习惯，具备良好的逻辑思维能力和问题解决能力；
3、扎实的编程和数据结构算法基础，具有较强的设计能力；
4、熟练掌握Java/Python中的一种或多种语言，以及相关的开发框架，了解框架的基础原理；
5、有服务器部署优化经验，以及K8S，Docker等微服务架构和分布式系统实践经验。熟练掌握MQ，Redis等常用web组件，熟悉数据库原理和常用性能优化技术；
6、有开发过高并发，高性能，高可用性系统经验优先；
7、熟悉大模型，深度学习，AIGC等相关AI技术原理优先；熟悉音视频编解码、传输技术的优先。`,
    date: "2025/8/14",
    locations: ["苏州", "北京"],
    type: "social",
    level: 1,
  },
  {
    category: "开发",
    title: "资深算法开发工程师",
    requirement: `1、参与算法工程化、算法落地部署工程优化、算法服务化等相关工作；
2、与算法团队对接，参与框架设计和关键技术预研并对核心算法进行实现和优化等；
3、负责系统架构设计，关键模块编写，性能优化。`,
    desc: `1、计算机、电子或通讯相关专业本科或以上学历，3年以上开发经验，能力突出者可忽略年限要求；
2、熟练使用C++，有并行计算、开发优化经验；CPU/GPU/NPU等开发经验；熟悉常用的数据结构和算法；
3、扎实的 C++开发能力，熟练使用交叉编译、具备linux、嵌入式等各平台开发能力；
4、熟练使用git/docker等开发工具，良好的团队协作和沟通能力；
5、有Python3开发经验、有AI相关领域背景从业经验加分。`,
    date: "2025/8/14",
    locations: ["北京"],
    type: "social",
    level: 1,
  },
  {
    category: "算法",
    title: "多模态大模型应用算法工程师",
    requirement: `1.负责多模态大模型（文本、图像、语音、视频等）的算法应用优化、工程化落地及商业化场景应用探索；
2.针对实际业务场景优化模型应用，推动技术方案在产品中的集成与迭代，实现技术成果的商业化变现；
3.跟踪多模态领域的前沿技术，探索创新方向并快速落地验证。`,
    desc: `1.计算机相关专业，本科以上学历；
2.具有视频理解、多模态大模型、大语言模型等一个或多个方向研究与商业化项目落地经验优先，能快速理解业务需求并转化为技术方案；
3.逻辑清晰，沟通能力强，具备出色的工程和代码能力。`,
    date: "2025/8/14",
    locations: ["北京"],
    type: "social",
    level: 2,
  },
];
export const campusJobs: JobDto[] = [
];
export const internJobs: JobDto[] = [
  {
    category: "产品",
    title: "AI产品实习生",
    requirement: `1. 参与智能体设计、搭建，大模型+数字人应用设计和实现；
2. 调研、梳理并复现复杂智能体搭建方法；
3. 设计并执行用例，测试调优智能体，优化智能体回复质量；
4. 以智能体应用开发为目标的其他工作，包括但不限于数据收集、处理。

岗位亮点：
1. 非螺丝钉岗位，能够以成员身份参与产品项目组，有资深前辈一对一指导；
2. 扁平化氛围，在轻松活跃的环境中进行前沿创新，工位落地窗风景优美，每天有帝都晚霞相伴。`,
    desc: `1. 硕士在读，专业方向不限；
2. 对AI行业具有浓厚兴趣，志于从事AI产品工作；
3. 了解LLM基本原理，掌握coze或同类智能体搭建基本方法，能够熟练使用生图、生视频工具；
4. 思维敏捷活跃，逻辑思维能力强，能够快速学习使用新工具新产品。`,
    date: "2025/8/14",
    locations: ["北京"],
    type: "intern",
    level: 1,
  },
  {
    category: "产品",
    title: "AI产品实习生",
    requirement: `1.参与小冰Agent相关产品市场调研、产品设计、Agent搭建、产品测试等工作，推动产品研发落地；
2.关注行业动态，探索大模型应用场景并推进项目落地。`,
    desc: `1.Base北京，本科及以上学历，有互联网产品实习经验，实习保证至少6个月；
2.熟练使用axure、figma等原型设计工具；
3.具有优秀的产品设计和审美能力，对产品设计有极致的追求；
4.执行力与沟通能力强，有一定的抗压能力与多线程并行处理能力；
5.对AI数字人及大模型产品有强烈的兴趣，关注新鲜事物，踏实能干。`,
    date: "2025/8/14",
    locations: ["北京"],
    type: "intern",
    level: 2,
  },
  {
    category: "职能",
    title: "AI产品实习生",
    requirement: `1.负责处理业务部门合同签约、邮寄、归档及整理；
2.负责处理合作方日常订单，涉及订单审理及订单内容配置；
3.负责针对合作方的日常答疑，根据业务情况及产品详情解答日常疑问；
4.负责维护合作方社群，主要涉及日常通知、信息收集、常见问题反馈；
5.上级领导安排的其他事务。
`,
    desc: `1.本科及以上在校生，专业不限制；
2.保证每周至少4天，连续6个月的实习；
3.熟练掌握excel软件；
4.做事有条理，认真细致，对待事务有责任心并具备良好的沟通能力。`,
    date: "2025/8/14",
    locations: ["北京"],
    type: "intern",
    level: 2,
  },
  {
    category: "职能",
    title: "算法实习生",
    requirement: `1.参与图像视频生成项目的研发； 
2.有机会独立完成数据收集、处理，模型设计、调优、部署等工作。
`,
    desc: `1.统招硕士及以上在读生， 计算机图形学或计算机视觉相关专业；
2.有一定的深度学习理论基础，了解基本的图像算法；
3.掌握基础的数据结构和算法知识；
4.熟悉Linux处理文件基本命令，熟练使用Python；
5.有过Tensorflow或Pytorch框架训练和调优模型的经验；
6.具有VAE/GAN/Diffusion等图像生成算法经验者优先；   
7.实习时间：6个月。`,
    date: "2025/8/14",
    locations: ["北京", "苏州"],
    type: "intern",
    level: 3,
  },
];
export const tabs = [
  { label: "社会招聘", value: "social", jobs: socialJobs },
  // { label: "校园招聘", value: "campus", jobs: campusJobs },
  { label: "实习生招聘", value: "intern", jobs: internJobs },
];
